import React, { Fragment } from "react";

export function nl2p(str: string): React.JSX.Element {
  const arr = str.split("\n").map((line, index) => <p key={index}>{line}</p>);

  return <>{arr}</>;
}
